import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check.df07aa70",
  "use": "check.df07aa70-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"check.df07aa70\">\n  <path fill=\"currentColor\" d=\"M9.333 14.379l-2.732-2.69a1.541 1.541 0 0 0-2.155 0 1.483 1.483 0 0 0 0 2.122l3.81 3.75c.595.585 1.56.585 2.155 0l9.143-9a1.483 1.483 0 0 0 0-2.122 1.541 1.541 0 0 0-2.155 0l-8.066 7.94z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol